// extracted by mini-css-extract-plugin
module.exports = {"pillarPoint":"points_pillarPoint__3p_tv","avatar":"points_avatar__3l4cj"};